import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import moment from "moment-timezone";
import { format, addDays } from "date-fns";
import DashboardCard from "../../pages/home/common/DashboardCard";
import {
  datewise_renewals,
  gymDashBoardReportGet,
  gymDashBoardReportGetKey,
  renewal_stat_detail,
} from "../../data/ApiEndpoints";
import { useGetFetch } from "../../data/Queries";
import { formatNumber } from "../../utils/utilityfunc";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import SalesCard from "../../pages/home/common/SalesCard";
import {
  convertStraight,
  convertThenFormat,
  currentDateOfTheMonth,
  formatDateTimezon,
  formatTimezoneThenStraight1,
} from "../common-data/Converts";
import { fetchUREStatsData } from "../../redux/reducers/apiSlice";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { fetchApiData } from "../../redux/reducers/commonApiSlice";
import CommonFilterStructure from "../common-components/CommonFilterStructure";
import PayoutsTable from "../components-bootstrap/PayoutsTable";
import AddLeadForm from "../lead-management/AddLeadForm";
import LeadFollowupV1 from "../lead-management/followup/LeadFollowupV1";
import { CheckCircleIcon, CrossCircleIcon, CallIcon } from "../../images/icons/icons";
import LeadJourney from "../lead-management/lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../lead-management/lms-v2/lms-payment-links/ClickToCall";

const UREcards = ({ userInfoData, prevAllFilters, prevFilters }) => {
  const dispatch = useDispatch();
  const { loading, ureStat } = useSelector((state) => state.api);
  const { data: commonData, loading: commonLoading } = useSelector(
    (state) => state.common
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = [
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const { selStartDate } = prevAllFilters;
  const startDate = selStartDate ? moment.tz(selStartDate, "Asia/Kolkata") : "";
  const today = moment.tz("Asia/Kolkata");

  const selectedMonth = startDate ? startDate.month() : "";
  const currentMonth = today.month();
  const selectedYear = startDate ? startDate.year() : "";
  const currentYear = today.year();

  const isCurrentMonth =
    (selectedMonth || selectedMonth === 0) && selectedYear
      ? selectedMonth === currentMonth && selectedYear === currentYear
      : true;
  const isFutureMonth =
    (selectedMonth || selectedMonth === 0) && selectedYear
      ? (selectedMonth > currentMonth && selectedYear === currentYear) ||
        selectedYear > currentYear
      : false;
  const isLastMonth = (!isCurrentMonth && !isFutureMonth) || false;

  const iniModVal = {
    cardModal: false,
    clickedCard: "",
    clickedCardValue: "",
    isModalOpen1: false,
    cardType1: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModVal);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    selectedGym: prevAllFilters.selectedGym
      ? prevAllFilters.selectedGym
      : !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.uid ||
            userInfoData?.user_id ||
            "",
        }
      : "",
    selectedOtherUsers: prevAllFilters.selectedOtherUsers
      ? prevAllFilters.selectedOtherUsers
      : "",
    // !isAdmin
    // ? {
    //     label: userInfoData?.name || "",
    //     value: userInfoData?.uid || userInfoData?.user_id || "",
    //   }
    // : "",
    selRenewalFromDay: "",
    selRenewalFromMonth: "",
    selRecurringStatus: "",
    selButtonEnabled: "",
    selAddNotAddToLead: "",
    selectedStartDate:
      modValues.clickedCard === "renewals_today" ||
      modValues.clickedCard === "past_renewals_today"
        ? currentDateOfTheMonth
        : prevAllFilters.selStartDate || "",
    selectedEndDate:
      modValues.clickedCard === "renewals_today" ||
      modValues.clickedCard === "past_renewals_today"
        ? currentDateOfTheMonth
        : prevAllFilters.selEndDate || "",

    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    sub_added_by: allFilters.selectedOtherUsers?.value || "",
    is_recurring: allFilters.selRecurringStatus?.value || "",
    is_btn_enabled: allFilters.selButtonEnabled?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const iniAllData = {
    statData: {},
    statDetail: [],
    pagination: [],
    inlineStat: {},
  };
  const [allData, setAllData] = useState(iniAllData);
  const [isFetchStatDetail, setIsFetchStatDetail] = useState(false);
  const { inlineStat = {} } = allData;

  // const sendableFilters = { gym_id: prevFilters.gym_id };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModVal);
    setIsFetchStatDetail(false);
    setAllData((prevState) => ({
      ...prevState,
      statDetail: [],
      pagination: [],
      inlineStat: {},
    }));
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  const onCloseModal1 = () => {
    setModValues((prevs) => ({
      ...prevs,
      isModalOpen1: false,
      cardType1: "",
      partialDetails: [],
      rowData: "",
    }));
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters((prevs) => ({
      ...prevs,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    }));
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters((prevs) => ({
      ...prevs,
      selectedStartDate: "",
      selectedEndDate: "",
    }));
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({
        ...prevs,
        search: allFilters.searchString,
      }));
    }
  };

  const {
    data: gymDashboardData,
    isLoading: isLoadingGymDashboard,
    isFetching: isFetchingGymDashboard,
    refetch: refetchGymDashboard,
  } = useGetFetch({
    token: userInfoData?.token,
    url: gymDashBoardReportGet,
    key: gymDashBoardReportGetKey,
    filters: prevFilters,
  });

  function isFetchingData() {
    try {
      if (isLoadingGymDashboard || isFetchingGymDashboard) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  function getUREStat(filters) {
    dispatch(
      fetchUREStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getStatDetail(filters, endPoint) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endPoint,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickCard = (cardName, cardValue) => {
    setModValues({
      cardModal: true,
      clickedCard: cardName,
      clickedCardValue: cardValue,
    });

    if (
      cardName === "renewals_today" ||
      cardName === "past_renewals_today" ||
      cardName === "renewals_this_month" ||
      cardName === "past_renewals_this_month"
    ) {
      setIsFetchStatDetail(true);
    } else {
      setIsFetchStatDetail(false);
    }
  };

  const cardConfigs = [
    {
      tagName: "total_expiry",
      label: "Expiring",
      value: `₹${convertThenFormat(
        allData.inlineStat?.total_expiry_amount || 0
      )} (${allData.inlineStat?.total_expiry || 0})`,
    },
    {
      tagName: "total_renewal",
      label: "Renewal",
      value: `₹${convertThenFormat(
        allData.inlineStat?.total_renewal_amount || 0
      )} (${allData.inlineStat?.total_renewal || 0})`,
    },
    {
      tagName: "total_recurring",
      label: "Recurring",
      value: `₹${convertThenFormat(
        allData.inlineStat?.total_recurring_price || 0
      )} (${allData.inlineStat?.total_recurring || 0})`,
    },
    {
      tagName: "total_non_recurring",
      label: "Non Recurring",
      value: `₹${convertThenFormat(
        allData.inlineStat?.total_non_recurring_price || 0
      )} (${allData.inlineStat?.total_non_recurring || 0})`,
    },
    {
      tagName: "renewal_percentage",
      label: "Renewal Percentage",
      value: `${convertThenFormat(inlineStat.renewal_percentage || 0)}%`,
    },
  ];

  useEffect(() => {
    const cardName = modValues.clickedCard;

    setAllFilters((prevs) => ({
      ...prevs,
      // selectedGym: prevAllFilters.selectedGym
      //   ? prevAllFilters.selectedGym
      //   : !isAdmin
      //   ? {
      //       label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
      //       value:
      //         userInfoData?.gym_id ||
      //         userInfoData?.uid ||
      //         userInfoData?.user_id ||
      //         "",
      //     }
      //   : "",
      selectedOtherUsers: prevAllFilters.selectedOtherUsers
        ? prevAllFilters.selectedOtherUsers
        : "",
      // !isAdmin
      // ? {
      //     label: userInfoData?.name || "",
      //     value: userInfoData?.uid || userInfoData?.user_id || "",
      //   }
      // : "",
      selectedStartDate:
        cardName === "renewals_today" || cardName === "past_renewals_today"
          ? currentDateOfTheMonth
          : prevAllFilters.selStartDate || "",
      selectedEndDate:
        cardName === "renewals_today" || cardName === "past_renewals_today"
          ? currentDateOfTheMonth
          : prevAllFilters.selEndDate || "",
    }));
  }, [prevAllFilters, modValues.clickedCard]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    const cardName = modValues.clickedCard;

    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      sub_added_by: allFilters.selectedOtherUsers?.value || "",
      is_recurring: allFilters.selRecurringStatus?.value || "",
      is_btn_enabled: allFilters.selButtonEnabled?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      view_type:
        modValues.clickedCard === "renewals_today" ||
        modValues.clickedCard === "past_renewals_today"
          ? allFilters.selRenewalFromDay?.value || ""
          : modValues.clickedCard === "renewals_this_month" ||
            modValues.clickedCard === "past_renewals_this_month"
          ? allFilters.selRenewalFromMonth?.value || ""
          : "",
      start_date:
        cardName === "renewals_today" || cardName === "past_renewals_today"
          ? currentDateOfTheMonth
          : allFilters.selectedStartDate || "",
      end_date:
        cardName === "renewals_today" || cardName === "past_renewals_today"
          ? currentDateOfTheMonth
          : allFilters.selectedEndDate || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedOtherUsers,
    allFilters.selRecurringStatus,
    allFilters.selRenewalFromDay,
    allFilters.selRenewalFromMonth,
    allFilters.selButtonEnabled,
    allFilters.selAddNotAddToLead,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    modValues.clickedCard,
  ]);

  useEffect(() => {
    try {
      refetchGymDashboard();
    } catch (error) {
      console.log(error);
    }
  }, [prevFilters]);

  useEffect(() => {
    getUREStat(prevFilters);
  }, [prevFilters]);

  useEffect(() => {
    if (ureStat?.status) {
      const { status, ...rest } = ureStat;
      setAllData((prevState) => ({
        ...prevState,
        statData: rest,
      }));
    }
  }, [ureStat]);

  useEffect(() => {
    if (isFetchStatDetail && modValues.clickedCard) {
      const cardName = modValues.clickedCard;

      filters.filter_type =
        cardName === "renewals_this_month"
          ? "renewal"
          : cardName === "past_renewals_this_month"
          ? "past_renewal"
          : "";
      filters.type =
        cardName === "renewals_today"
          ? "total_renewals"
          : cardName === "past_renewals_today"
          ? "total_past_renewals"
          : "";

      getStatDetail(
        filters,
        cardName === "renewals_today" || cardName === "past_renewals_today"
          ? datewise_renewals
          : cardName === "renewals_this_month" ||
            cardName === "past_renewals_this_month"
          ? renewal_stat_detail
          : ""
      );
    }
  }, [isFetchStatDetail, filters, modValues.clickedCard]);

  useEffect(() => {
    if (commonData?.status && commonData?.data?.length > 0) {
      const { data, pagination } = commonData;
      setAllData((prevState) => ({
        ...prevState,
        statDetail: data,
        pagination: pagination,
        inlineStat: commonData?.stats,
      }));
    } else {
      setAllData((prevState) => ({
        ...prevState,
        statDetail: [],
        pagination: [],
        inlineStat: {},
      }));
    }
  }, [commonData]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "is_btn_enabled",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#C90808",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.is_btn_enabled ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
                opacity: row?.is_btn_enabled ? 1 : 0.5,
              }}
              onClick={() =>
                row?.is_btn_enabled &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen1: true,
                  rowData: row,
                  cardType1: "add-to-lead",
                }))
              }
              disabled={!row?.is_btn_enabled}
            >
              Add To LMS
            </button>
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#000",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.added_to_lead ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
                opacity: row?.added_to_lead ? 1 : 0.5,
              }}
              onClick={() =>
                row?.added_to_lead &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen1: true,
                  rowData: row,
                  // cardType1: "follow-up",
                  cardType1: "view-lead-journey",
                }))
              }
              disabled={!row?.added_to_lead}
            >
              View Lead
            </button>
          </div>
        );
      },
    },
    {
      dataField: "added_to_lead",
      text: "Added To Lead",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.added_to_lead ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "user info",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "payment_location",
      text: "Payment Location",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.payment_location ? row.payment_location : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "experience_level",
      text: "Experience Level",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.experience_level || "NA"}</span>;
      },
    },
    {
      dataField: "last_checkin",
      text: "Last Check-in",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.last_checkin || "NA"}
            {row?.checkin_time && (
              <>
                <br />
                <small>{row?.checkin_time}</small>
              </>
            )}
            {row?.last_checkin_days_ago && (
              <>
                <br />
                <small style={{ color: "#666" }}>
                  {row?.last_checkin_days_ago?.replace(/_/g, " ")}
                </small>
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {/* <small style={{ textTransform: "initial", color: "gray" }}>
              {row?.gym_id || ""}
            </small>
            <br /> */}
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "plan",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150" style={{ lineHeight: "31px" }}>
            {row?.type?.replace(/_/g, " ") || "NA"}
            <br />({row?.plan_name?.replace(/_/g, " ") || ""})
            <br />
            <small
              style={{
                padding: "10px",
                borderRadius: "4px",
                color: "#fff",
                backgroundColor: row?.subs_reference_id ? "#0F67B1" : "#36BA98",
              }}
            >
              {row?.subs_reference_id ? "Recurring" : "Non Recurring"}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (_, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => (
        <span
          className={`tb-data ${row?.is_partial === "true" ? "link" : ""}`}
          onClick={() =>
            row?.is_partial === "true"
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen1: true,
                  cardType1: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial === "true" ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    // (modValues.clickedCard === "past_renewals_today" ||
    //   modValues.clickedCard === "past_renewals_this_month") && {
    //   dataField: "last_expiry_date",
    //   text: "Expired On",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.last_expiry_date
    //           ? formatTimezoneThenStraight1(row.last_expiry_date)
    //           : "-"}
    //       </span>
    //     );
    //   },
    // },
    // (modValues.clickedCard === "renewals_today" ||
    //   modValues.clickedCard === "renewals_this_month") &&
    {
      dataField: "last_expiry_date",
      text: "Renewal Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background:
                modValues.clickedCard === "renewals_today" ||
                modValues.clickedCard === "renewals_this_month"
                  ? "rgb(180, 231, 185)"
                  : "#f7e5e5",
              color:
                modValues.clickedCard === "renewals_today" ||
                modValues.clickedCard === "renewals_this_month"
                  ? "rgb(10, 112, 27)"
                  : "#cd0909",
            }}
          >
            {row?.last_expiry_date
              ? formatTimezoneThenStraight1(row.last_expiry_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.start_date
              ? formatTimezoneThenStraight1(row.start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: `${
        modValues.clickedCard === "past_renewals_today" ||
        modValues.clickedCard === "past_renewals_this_month"
          ? "End Date"
          : "Expire Date"
      }`,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.expire_date
              ? formatTimezoneThenStraight1(row.expire_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const isActive = row?.status === "active";

        return (
          <div
            className="flex-k"
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "sub_added_by",
      text: "Sub Added By",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.sub_added_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.sub_added_by_mobile || ""}
              <br />
              {row?.sub_added_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "click_to_call",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen1: true,
                  cardType1: "click-to-call",
                  rowData: row,
                }))
              }
            >
              <CallIcon color="#000" />
            </button>
          </div>
        );
      },
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.cardModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer home-card-container-modal`}>
          <ModalHeadAndClose
            title={`${
              modValues.clickedCard === "renewals_today"
                ? "renewals today (Advance and Same Day Renewals)"
                : modValues.clickedCard === "renewals_this_month"
                ? "renewals this month (Advance and Same Month Renewals)"
                : modValues.clickedCard === "unpaid_members"
                ? " "
                : modValues.clickedCard?.replace(/_/g, " ")
            }`}
            onClose={onCloseModal}
          />

          {modValues.clickedCard === "unpaid_members" ||
          modValues.clickedCard === "expiring_today" ||
          modValues.clickedCard === "expiring_this_month" ? (
            <SalesCard
              user={userInfoData}
              clickedCard={modValues.clickedCard}
              prevPrevAllFilters={prevAllFilters}
              filters={prevFilters}
              prevSelGym={prevAllFilters.selectedGym}
              isURE={true}
            />
          ) : modValues.clickedCard === "renewals_today" ||
            modValues.clickedCard === "past_renewals_today" ||
            modValues.clickedCard === "renewals_this_month" ||
            modValues.clickedCard === "past_renewals_this_month" ? (
            <>
              <CommonFilterStructure
                from={"ure-stat-detail"}
                decryptedText={userInfoData}
                setFilters={setAllFilters}
                filters={allFilters}
                onClickReset={onClickReset}
                onClickSearch={onClickSearch}
                searchFilterApplied={searchFilterApplied}
                openDateRanger={openDateRanger}
                handleDateRangeChange={handleDateRangeChange}
                setOpenDateRanger={setOpenDateRanger}
                rangeState={rangeState}
                clearDateRanger={clearDateRanger}
                isDisabledDate={
                  modValues.clickedCard === "renewals_today" ||
                  modValues.clickedCard === "past_renewals_today"
                }
                clickedCard={modValues.clickedCard}
                otherUserLabel={"Added By"}
              />

              <div className="cards-container cards-grid-container grid-5 mt-2rem non-img">
                {cardConfigs.map(({ tagName, label, value }) => {
                  if (
                    modValues.clickedCard === "renewals_this_month" &&
                    (tagName === "total_expiry" ||
                      tagName === "renewal_percentage")
                  ) {
                    return (
                      <DashboardCard
                        key={tagName}
                        tagName={tagName}
                        cardLabel={label}
                        value={value}
                      />
                    );
                  }

                  if (
                    modValues.clickedCard !== "renewals_this_month" &&
                    (tagName === "total_expiry" ||
                      tagName === "renewal_percentage")
                  ) {
                    return null;
                  }

                  return (
                    <DashboardCard
                      key={tagName}
                      tagName={tagName}
                      cardLabel={label}
                      value={value}
                    />
                  );
                })}
              </div>

              <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
                {commonLoading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={allData.statDetail}
                    tableColumns={tbColumns}
                    tablePagination={allData.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                )}
              </div>
            </>
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={modValues.isModalOpen1}
        onRequestClose={onCloseModal1}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer  ${
            modValues.cardType1 === "partial_details"
              ? "mod-width-50p"
              : modValues.cardType1 === "partial_details"
              ? "mod-width-50p"
              : modValues.cardType1 === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.cardType1 === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.cardType1 === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.cardType1 === "add-to-lead" || modValues.cardType1 === "click-to-call" ? null : modValues.cardType1 === "view-lead-journey" ? (
            <ModalHeadAndClose
              title={`Lead Details - ${modValues.rowData?.user_name || ""}`}
              onClose={onCloseModal1}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                modValues.cardType1 === "partial_details"
                  ? "Partial Details"
                  : ""
              }`}
              onClose={onCloseModal1}
            />
          )}

          {modValues.cardType1 === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : modValues.cardType1 === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={onCloseModal1}
              callFunction={() => {
                if (isFetchStatDetail && modValues.clickedCard) {
                  const cardName = modValues.clickedCard;

                  filters.filter_type =
                    cardName === "renewals_this_month"
                      ? "renewal"
                      : cardName === "past_renewals_this_month"
                      ? "past_renewal"
                      : "";
                  filters.type =
                    cardName === "renewals_today"
                      ? "total_renewals"
                      : cardName === "past_renewals_today"
                      ? "total_past_renewals"
                      : "";

                  getStatDetail(
                    filters,
                    cardName === "renewals_today" ||
                      cardName === "past_renewals_today"
                      ? datewise_renewals
                      : cardName === "renewals_this_month" ||
                        cardName === "past_renewals_this_month"
                      ? renewal_stat_detail
                      : ""
                  );
                }
              }}
              rowData={modValues.rowData}
              isURE={true}
              ureCard={"renewal"}
            />
          ) : modValues.cardType1 === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues?.rowData}
              closeFollowupModal={onCloseModal1}
              // pageName="ure"
              // prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
              //   filters
              // )}
            />
          ) : modValues.cardType1 === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.cardType1 === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={onCloseModal1}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <div className="cards-container cards-grid-container">
        {isFetchingData() ? (
          <ReactVortoxSpinner />
        ) : (
          <>
            {isCurrentMonth && (
              <DashboardCard
                tagName={"members"}
                cardLabel={"Expiring today"}
                value={`₹${
                  gymDashboardData?.data?.expiringTodayPrice
                    ? convertThenFormat(
                        gymDashboardData.data.expiringTodayPrice
                      )
                    : 0
                }(${
                  gymDashboardData?.data?.expiringToday
                    ? formatNumber(gymDashboardData.data.expiringToday)
                    : 0
                })`}
                onClickCard={onClickCard}
              />
            )}

            {!isLastMonth && (
              <DashboardCard
                tagName={"members"}
                cardLabel={"Expiring this month"}
                value={`₹${
                  gymDashboardData?.data?.expiringThisMonthPrice
                    ? convertThenFormat(
                        gymDashboardData.data.expiringThisMonthPrice
                      )
                    : 0
                }(${
                  gymDashboardData?.data?.expiringThisMonth
                    ? formatNumber(gymDashboardData.data.expiringThisMonth)
                    : 0
                })`}
                onClickCard={onClickCard}
              />
            )}

            {!isFutureMonth && (
              <DashboardCard
                tagName={"members"}
                cardLabel={"Unpaid Members"}
                value={`₹${
                  gymDashboardData?.data?.unpaidMembersPrice
                    ? convertThenFormat(
                        gymDashboardData.data.unpaidMembersPrice
                      )
                    : 0
                }(${
                  gymDashboardData?.data?.unpaidMembers
                    ? formatNumber(gymDashboardData.data.unpaidMembers)
                    : 0
                })`}
                onClickCard={onClickCard}
              />
            )}
          </>
        )}

        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <>
            {isCurrentMonth && (
              <>
                <DashboardCard
                  tagName={"members"}
                  cardLabel={"renewals today"}
                  value={`₹${convertThenFormat(
                    allData.statData?.tRenewalStats?.total_price || 0
                  )}(${convertThenFormat(
                    allData.statData?.tRenewalStats?.total || 0
                  )})`}
                  onClickCard={onClickCard}
                  isCardClickable={true}
                />

                <DashboardCard
                  tagName={"members"}
                  cardLabel={"past renewals today"}
                  value={`₹${convertThenFormat(
                    allData.statData?.tpRenewalStats?.total_price || 0
                  )}(${convertThenFormat(
                    allData.statData?.tpRenewalStats?.total || 0
                  )})`}
                  onClickCard={onClickCard}
                  isCardClickable={true}
                />
              </>
            )}

            {!isFutureMonth && (
              <>
                <DashboardCard
                  tagName={"members"}
                  cardLabel={"renewals this month"}
                  value={`₹${convertThenFormat(
                    allData.statData?.renewalStats?.total_price || 0
                  )}(${convertThenFormat(
                    allData.statData?.renewalStats?.total || 0
                  )})`}
                  onClickCard={onClickCard}
                  isCardClickable={true}
                />

                <DashboardCard
                  tagName={"members"}
                  cardLabel={"past renewals this month"}
                  value={`₹${convertThenFormat(
                    allData.statData?.pRenewalStats?.total_price || 0
                  )}(${convertThenFormat(
                    allData.statData?.pRenewalStats?.total || 0
                  )})`}
                  onClickCard={onClickCard}
                  isCardClickable={true}
                />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default UREcards;
